import { Link } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';

import './index.scss';

import Logo from '../../assets/images/LG-Cobalt@2x.png';
import Back from "../../assets/icons/back.svg"

import { RiArrowDropDownLine } from "react-icons/ri";
import { FaBars } from 'react-icons/fa';  // ícone de hambúrguer
import { Icon } from '../../components/icon';

export const Header = ({ setOption, showHeaderButtons }) => {
  const empresaDropDown = useRef(null);
  const voceDropDown = useRef(null);
  const sobreDropDown = useRef(null);

  // Controle de dropdowns
  const [isEmpresaDropdownOpen, setIsEmpresaDropdownOpen] = useState(false);
  const [isVoceDropdownOpen, setIsVoceDropdownOpen] = useState(false);
  const [isSobreDropdownOpen, setIsSobreDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);  // Controle do menu no mobile

  // Alternar a visibilidade dos dropdowns
  const toggleEmpresaDropdown = () => setIsEmpresaDropdownOpen(!isEmpresaDropdownOpen);
  const toggleVoceDropdown = () => setIsVoceDropdownOpen(!isVoceDropdownOpen);
  const toggleSobreDropdown = () => setIsSobreDropdownOpen(!isSobreDropdownOpen);

  // Atualizar a opção selecionada
  const handleOptionClick = (option) => {
    setOption(option);
    setIsEmpresaDropdownOpen(false);
    setIsVoceDropdownOpen(false);
    setIsSobreDropdownOpen(false);
    setIsMenuOpen(false);
  };

  // Alternar a visibilidade do menu no mobile
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {

      if (empresaDropDown.current && !empresaDropDown.current.contains(event.target)) {
        setIsEmpresaDropdownOpen(false)
      }

      if (voceDropDown.current && !voceDropDown.current.contains(event.target)) {
        setIsVoceDropdownOpen(false)
      }

      if (sobreDropDown.current && !sobreDropDown.current.contains(event.target)) {
        setIsSobreDropdownOpen(false)
      }
  };

  document.documentElement.addEventListener('click', handleClickOutside);

  return () => {
    document.documentElement.removeEventListener('click', handleClickOutside);
  };
  }, [])

  return (
    <div className='container-header'>

      {/* Menu hambúrguer */}
      <div className='menu-icon' onClick={toggleMenu}>
        {isMenuOpen ? <Icon icon={Back}style={{height:30}} size={22}/>  : <FaBars className='hamburger-icon' />}
      </div>
      <div className='icon-links'>
        <Link to="" className='logotipo-cobalt'>
          <img alt={Logo} src={Logo} />
        </Link>

        {/* Menu principal */}
        <div className={`categories-header ${isMenuOpen ? 'open' : ''}`}>

          <div ref={sobreDropDown} className='link-dropdown'  onClick={toggleSobreDropdown}>
            <Link to='#' className='link-style'> SOBRE A COBALT <RiArrowDropDownLine className='icon-select-header' size={30} /> </Link>
          
            {isSobreDropdownOpen && (
              <div  className="dropdown-menu">
                <Link className='link-style' to="/quem-somos" onClick={() => handleOptionClick('QuemSomos')}> Quem Somos </Link>
                <Link className='link-style' to="/operacional-passo-a-passo" onClick={() => handleOptionClick('OperacionalPassoAPasso')}> Operacional Passo a Passo </Link>
              </div>
            )}
          </div>

          {/* Menu para sua empresa */}
          <div ref={empresaDropDown} className='link-dropdown'  onClick={toggleEmpresaDropdown}>
            <Link to='#' className='link-style'> PARA SUA EMPRESA <RiArrowDropDownLine className='icon-select-header'size={30} /> </Link>
          
            {isEmpresaDropdownOpen && (
              <div  className="dropdown-menu">
                <Link className='link-style' to="/cambio-pronto" onClick={() => handleOptionClick('CambioPronto')}> Câmbio Pronto </Link>
                <Link className='link-style' to="/produtos-de-credito" onClick={() => handleOptionClick('ProdutosCredito')}> Produtos de Crédito </Link>
                <Link className='link-style' to="/produtos-de-protecao" onClick={() => handleOptionClick('ProdutosProtecao')}> Produtos de Proteção </Link>
                {/* <Link className='link-style' to="/multiplas-cotacoes" onClick={() => handleOptionClick('MultiplasCotacoes')}> Multiplas Cotações </Link>
                <Link className='link-style' to="/produtos-exclusivos" onClick={() => handleOptionClick('ProdutosExclusivos')}> Produtos Exclusivos </Link> */}
              </div>
            )}
          </div>


          <div ref={voceDropDown} className='link-dropdown'  onClick={toggleVoceDropdown}>
            <Link to='#' className='link-style'> PARA VOCÊ <RiArrowDropDownLine className='icon-select-header'size={30} /> </Link>
          
            {isVoceDropdownOpen && (
              <div  className="dropdown-menu">
                <Link className='link-style' to="/produtos-para-voce" state={{tab:1}} onClick={() => handleOptionClick('RecebimentoSalarios')}> Recebimento de salários</Link>
                <Link className='link-style' to="/produtos-para-voce" state={{tab:2}} onClick={() => handleOptionClick('CambioViagens')}> Câmbio para viagens </Link>
                <Link className='link-style' to="/produtos-para-voce" state={{tab:3}} onClick={() => handleOptionClick('Intercambio')}> Intercâmbio </Link>
                <Link className='link-style' to="/produtos-para-voce" state={{tab:3}} onClick={() => handleOptionClick('EstudeExterior')}> Estude no exterior </Link>
              </div>
            )}
          </div>

            <div className='block-buttons'>
              <Link to={"/cadastro"} className='button-header primary'> Abra sua conta </Link>
              <a className="button-header" href="https://www.iamsimple.com.br/cobalt" target="_blank" rel="noopener noreferrer"> Acessar Plataforma  </a>
            </div>
          
        </div>
      </div>
      <div className='buttons-header' style={{display: !showHeaderButtons? "none" : ""}}>
        <Link to={"/cadastro"} className='button-header primary'> Abra sua conta </Link>
        <a className="button-header" href="https://www.iamsimple.com.br/cobalt" target="_blank" rel="noopener noreferrer"> Acessar Plataforma  </a>

      </div>

    </div>
  );
}
